export default "<div>Add a Kendo UI for Angular component here</div>\r\n";